import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

const SubRegions = ({ subregions, onSetSubregions }) => {
  const addSubregionField = () => {
    const newId = subregions.length > 0 ? Math.max(...subregions.map((r) => r.id)) + 1 : 1;
    onSetSubregions([...subregions, { id: newId, name: "" }]);
  };

  const deleteSubregionField = (id) => {
    // prevent deleting if there's only one subregion
    if (subregions.length <= 1) {
      return;
    }

    onSetSubregions(subregions.filter((subregion) => subregion.id !== id));
  };

  const handleSubregionChange = (id, value) => {
    onSetSubregions(subregions.map((subregion) => (subregion.id === id ? { ...subregion, name: value } : subregion)));
  };

  return (
    <div className="company-section mb-5 p-4 bg-light border rounded">
      <h5 className="text-white p-2" style={{ backgroundColor: "#243544" }}>
        Sub Regions
      </h5>

      <Form.Label>Sub Regions</Form.Label>
      {subregions.map((subregion, index) => (
        <Row key={subregion.id} className="mb-3">
          <Col xs={9}>
            <div className="d-flex">
              <Form.Control
                type="text"
                placeholder="Enter Sub Region Name"
                value={subregion.name}
                onChange={(e) => handleSubregionChange(subregion.id, e.target.value)}
                required
                className="me-2"
              />

              {index === subregions.length - 1 && (
                <Button variant="outline-primary" onClick={addSubregionField} className="d-flex align-items-center me-2">
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              )}

              {subregions.length > 1 && (
                <Button variant="outline-danger" onClick={() => deleteSubregionField(subregion.id)} className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              )}
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default SubRegions;
